import { useAppDispatch } from 'hooks/use-app-dispatch'
import { useAuthUser } from 'next-firebase-auth'
import { useEffect } from 'react'
import { loadStats } from 'utils/database/load-stats'

export const useLoadStats = () => {
  const dispatch = useAppDispatch()
  const { id } = useAuthUser()

  useEffect(() => {
    ;(async () => {
      if (id) await loadStats(dispatch, id)
    })()
    // Safe to add dispatch to the dependencies array. Dispatch wont change.
  }, [dispatch, id])
}
